import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  name: {
    fontSize: "1.313rem",
    fontWeight: "bold",
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  checkboxInput: {
    marginTop: theme.spacing(2),
  },
}))

export default styles
